export const TranslationsZHT = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
        zht: '繁體中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: 'ZHT',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
        zht: '繁體',
    },
    // BASE
    phrases: {
        order_online: "网上订购",
        cart: "购物车",
        open_24: "24 小时",
        closed: "已下班",
        free: "免费",
        something_went_wrong: "出问题了",
        try_again: "再试一次",
    },
    constants: {
        calendar: {
            days: {
                monday: "星期一",
                tuesday: "星期二",
                wednesday: "星期三",
                thursday: "星期四",
                friday: "星期五",
                saturday: "星期六",
                sunday: "星期日",
            },
        },
        services: {
            pickup: "到店自提",
            delivery: "外卖配送",
            dine_in: "堂食",
            table_booking: "订座",
        },
        payment: {
            method: {
                cash: "现金",
                card: "银行储蓄卡",
                stripe: "信用卡",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "定制",
            },
            backend_method: {
                cash: "现金",
                card: "银行储蓄卡",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                custom: "定制",
            },
            status: {
                success: "支付成功",
                pending: "等待支付",
                error: "错误",
                refunded: "已退款",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "删除",
                drop_here: "把您的文件放在这里或者点击选择一个",
                accepts: "接受 {{fileTypes}} 文件",
                errors: {
                    max_files: "可允许的最多文件数目 {{number}} ",
                    max_size: "最大的文件大小 {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            buttons: {
                order: {
                    book_order: '訂座 / 網上訂購',
                    order_online: '網上訂購',
                    book_table: '訂座',
                    order: '訂購',
                    book: '訂座',
                    cart: '購物車',
                    restart: '重新開始',
                    closed: '營業時間已過',
                    not_accepting: '不接受訂單',
                },
            },
        },
        modals: {
            auth: {
                login: '登錄',
                register: '註冊',
                register_commence: '繼續',
                register_complete: '創建帳戶',
                register_confirmation_sent: '確認碼已經發送到您的電子郵箱地址。請在下面輸入以繼續',
                register_confirmation_resent: '確認碼已再次發送，請檢查您的垃圾郵件或重新操作',
                register_restart: '重新開始',
                register_resend_code: '重發確認碼',
                login_placeholder: '電子郵箱',
                password_placeholder: '密碼',
                confirmation_code_placeholder: '電子郵箱確認碼',
                accept_terms: '接受條款及細則',
                accept_terms_view: '查看',
                login_facebook: '通過Facebook登錄',
                login_google: '通過Google登錄',
                benefits: '登錄或創建一個帳戶來保存您所有的訂單',
                logged_in: '成功登錄',
                logged_out: '退出',
                error_generic: '如有問題，請再試一次或者聯繫我們',
                error_accept_terms: '請接受條款及細則',
                error_password_length: '密碼最少6個字符',
                error_social: '如有問題，再試一次或者聯繫我們',
                error_confirmation_code: '確認碼無效',
                error_invalid_code: '確認碼無效',
                error_exists: '用戶已存在',
                error_invalid_email_pass: '電子郵箱地址或者密碼無效',
            },
            booking: {
                form: {
                    name: '全名',
                    email: '電子郵箱地址',
                    phone: '電話號碼',
                    number_of_people: '人數',
                    number_of_people_limit: '最多人數 ({{people}})',
                    notes: '註釋/特別要求',
                    submit: '提交訂座要求',
                    email_optional: '（選填）',
                    date: '日期',
                    duration: '時長',
                    seating: '可預訂時段',
                    number_of_guests: '人數',
                    notes_placeholder: '過敏、場合、座位偏好',
                    reserving: '正在預訂...',
                    reserve_table: '預訂座位',
                    please_choose_a_date_and_time: '請選擇日期和時間。',
                    invalid_people: '人數須介於 {{min}} 到 {{max}} 之間。',
                    party_size_max_fallback: '允許的上限',
                    loading_available_times: '正在載入可預訂時段…',
                    select_a_date_to_see_available_times: '選擇日期以查看可預訂時段。',
                    no_times_available_for_this_date: '此日期沒有可預訂時段，請選擇其他日期。',
                    shift: '時段',
                    service_times: '營業時段',
                    new_shift: '新時段',
                    time: '個時段',
                    times: '個時段',
                    unavailable: '已滿',
                    available: '可預訂',
                    required_name: '請輸入您的姓名。',
                    required_phone: '請輸入您的電話號碼。',
                    required_email: '請輸入您的電子郵件。',
                    invalid_email: '請輸入有效的電子郵件。',
                    required_terms: '預訂前請接受條款。',
                    missing_custom_fields: '請完成所有必填問題。',
                    reservation_is_unavailable: '暫不接受預訂。',
                    please_contact_the_restaurant_directly: '請直接聯絡餐廳。',
                    almost_done: '即將完成',
                    your_details: '您的資料',
                    tell_us_who_s_coming: '請告訴我們來客資訊，以便確認您的預訂。',
                    book_your_table: '預訂您的座位',
                    choose_a_time_that_works_for_you: '選擇一個適合您的時間。',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: '送出預訂請求，其餘事宜由餐廳處理。',
                    select_date: '選擇日期',
                    standard: '標準',
                    minutes: '分鐘',
                    next: '下一步 →',
                    back: '← 返回',
                    accept_terms: '我接受條款和條件。',
                    info_1: '當您的訂座要求被接受或拒絕時，您將收到一封電子郵件通知',
                },
                errors: {
                    not_found: '預訂不存在，可能被刪除了',
                    generic: '如果有問題，請刷新頁面或與我們聯繫',
                    something_went_wrong: '出問題了',
                    accept_terms: '請接受條款及細則',
                    required_phone: '請輸入您的電話號碼',
                    required_email: '請輸入您的電子郵箱地址',
                    required_name: '請輸入您的姓名',
                    invalid_email: '請輸入一個有效的電子郵箱地址',
                    booking_capacity_threshold: "此時段已訂滿，請嘗試其他時段。",
                    slot_unavailable: "此人數已訂滿，請嘗試其他時段。",
                    booking_date_paused: "此日期已暫停預訂，請選擇其他日期。",
                    invalid_table_assignment: "這些座位無法容納您的人數，請選擇其他時段。",
                    exceeded_order_limit: "預訂請求過多，請稍後再試。",
                    validation_failed_recaptcha_v3: "偵測到異常流量。您是否正在使用 VPN？請完成上方驗證後重試。",
                    validation_failed_recaptcha_v2: "無法開始預訂。請重試或使用其他方式。如果您正在使用 VPN，請先關閉。",
                    booking_already_exists: "此預訂已送出。請查看您的電子郵件或開啟預訂連結。",
                    invalid_party_size: "請選擇有效的人數。",
                    invalid_request: "請求無效。請重新整理頁面後重試。",
                    table_booking_unavailable: "座位預訂無法使用。",
                },
            },
            cart: {
                title: '購物車',
                proceed_to_checkout: '進入結算',
                edit_dish: '編輯',
                remove_dish: '刪除',
                no_items_1: '購物車內無商品',
                no_items_2: '請先添加商品以繼續',
                free_delivery_notice: '免配送費訂購金額 {{value, currency}}',
                errors: {
                    min_order_promo: '在使用此優惠前，購物車最低金額爲 {{value, currency}} ',
                    min_order_delivery: '購物車最低起送金額 {{value, currency}} ',
                },
                promo: {
                    heading: '優惠碼',
                    placeholder: '輸入您的優惠碼',
                    add: '添加優惠碼',
                    title: '添加到購物車的優惠活動名稱 {{name}} ',
                    fixed_discount: '優惠 {{value, currency}} ',
                    percent_discount: '優惠 {{value}}% ',
                    added_to_cart: '添加到購物車的優惠',
                    errors: {
                        not_found: '沒有找到優惠',
                        disabled: '優惠活動已停止',
                        not_available: '暫無優惠活動',
                        logged_in_only: '必須登錄才能使用這個優惠',
                        already_used: '您已經使用過這個優惠',
                        invalid: '此優惠不再有效',
                        invalid_service: '此優惠不適用於您所選擇的服務',
                        generic: '哦... 出問題了，已經登錄過了',
                        dishes_required_multi: '此優惠只適用於指定菜名被加入到您的購物車時',
                        dishes_required_single: "此优惠只适用于 '{{dish}}'",
                    },
                },
                tip: {
                    title: '訂單小費',
                    placeholder: '添加訂單小費',
                },
            },
            checkout: {
                title: '結賬',
                subtitle: '確認您的訂單',
                details: {
                    service: '服務',
                    due: 'Due',
                    due_now_asap: '馬上/儘快',
                    address: '配送地址',
                    total: '總金額',
                    table: '桌子',
                    store_location: '商家地址',
                },
                customer: {
                    title: '用戶',
                    subtitle: '登錄以保存您的訂單和詳細信息',
                    button: '登錄',
                    name: '全名',
                    email: '電子郵箱地址',
                    phone: '電話號碼',
                    phone_important: '電話號碼 (重要)',
                    notes: '訂單備註',
                    delivery_notes: '配送說明 / 訂單備註',
                    optional: '可選',
                },
                payment: {
                    title: '支付方式',
                },
                accept_terms: '接受條款及細則',
                accept_terms_view: '查看',
                processing_order: '處理訂單中',
                warning: {
                    different_payment_currency: '商店價格貨幣是 {{store_currency}} 但是支付方式貨幣是 {{payment_currency}}',
                    closing_soon: '營業就快結束，請必須在 {{value}} 分鐘內訂購',
                    closed: '抱歉，服務已經停止，暫不接受訂單',
                    expired: '我們不能在您指定的時間完成您的訂單，請選擇往後的日期或時間',
                },
                errors: {
                    stripe_generic: '信用卡錯誤，請重試或用其他方法',
                    stripe_loading_fail: '下載付款格式錯誤，請重試',
                    something_went_wrong: '出問題了',
                    paypal_generic: 'PayPal出了問題，再試一次或者選擇另一種支付方式',
                    payment_fail: '付款失敗，請重試或選擇其他付款方式',
                    payment_cancelled: '已取消付款，請重試或選擇其他付款方法',
                    payment_error: '在線支付錯誤，請重試或選擇另一種付款方法',
                    card_declined: '您的信用卡被拒絕，無法處理付款',
                    promo_max_uses_exceeded: "此促銷代碼已達到使用上限，無法再使用。",
                    store_closed: '商店已到下班時間，不再接受訂單',
                    accept_terms: '請接受條款及細則',
                    required_payment: '請選擇付款方式',
                    required_phone: '請輸入您的電話號碼',
                    required_email: '請輸入您的電子郵箱地址',
                    required_name: '請輸入您的名字',
                    invalid_email: '請輸入一個有效的電子郵箱地址',
                    invalid_phone: '請輸入一個有效的電話號碼',
                    invalid_order_amount: '此付款方式所需的最低金額',
                    closed: '商店就快關門/關門了，不再接受訂單',
                    promo_login_required: '必須登錄才能使用這個優惠碼',
                    promo_used: '您已經使用過這個優惠',
                    exceeded_order_limit: '我們目前收到很多訂單。請稍後選擇一個時間。',
                    exceeded_order_limit_later: "我们无法在您选择的时间履行订单。请您选择一个更晚的日期或时间。",
                },
                button: {
                    continue: '繼續付款',
                    place_order: '下訂單',
                },
            },
            customer: {
                age_v: {
                    title: '年齡驗證',
                    required_for_items: '需要訂購特定商品',
                    min_age: '最低年齡: {{age}} 歲',
                    est_time: '估計驗證時間: {{time}} 小時',
                    upload_description: '上傳您的身份證件。一經覈實，我們將通過電子郵件通知您。最多上傳2張圖片，每張圖片的最大尺寸爲2 MB',
                    pending_description_1: '謝謝您提交文件。當您獲得批准時，您將收到電子郵件通知',
                    pending_description_2: '刷新頁面以更新您的驗證狀態。估計驗證時間 {{time}} 小時',
                    approved_description: '您的帳戶已經通過驗證，您可以從受限制的菜單點菜',
                    rejected_description: '您的身份證件已被拒絕。如果您想再試一次，請重新上傳您的身份證件',
                    upload: '上傳',
                    reupload: '重新上傳文件',
                    go_back: '返回',
                    view_document: '查看文件 {{number}}',
                    status: {
                        unverified: '未驗證',
                        pending: '等待批准',
                        approved: '成功驗證',
                        rejected: '拒絕',
                    },
                },
                headings: {
                    sessions: '瀏覽次數',
                    orders: '訂單',
                    spend: '已消費',
                    order_history: '訂單歷史',
                    loyalty_points: '忠誠度積分',
                },
            },
            dish: {
                add: '加入購物車',
                edit: '更新選項',
                notes: '備註',
                ingredients: {
                    title: '配料',
                    uncheck_remove: '取消勾選項',
                },
                ingredients_title: '配料',
                combo: {
                    choose_dish: '選擇一個菜名',
                },
                option_sets: {
                    conditions: {
                        select_one: '選擇一個(必選)',
                        select_one_optional: '選擇一個(可選)',
                        select_between: '選擇 {{min}} - {{max}} (必選)',
                        select_at_least: '至少選擇 {{qty}} (必選)',
                        select_up_to: '最多可選擇 {{qty}} (可選)',
                        select_multiple: '選擇多個 (可選)',
                        free_amount: '前 {{qty}} 免費 / {{selected}} 選擇',
                    },
                },
                error: '請更正任何紅色標記的選項',
                added_to_cart: '購物車清單',
            },
            map: {
                zone_fee: '配送費',
                view_in_google: '在 Google 地圖查看',
            },
            portal_go_back: {
                title: '返回到<搜索餐館>?',
                description: '您購物車中的所有選項都將丟失',
                cancel: '取消',
                proceed: '返回',
            },
            order: {
                config: {
                    services: {
                        title: '選擇服務',
                        table_booking: '訂座',
                    },
                    address_custom: {
                        input_placeholder: '輸入您的地址',
                    },
                    address: {
                        input_placeholder: '尋找您的送貨地址',
                        extras_placeholder: '可選:單位編號、建築名稱等',
                        search_placeholder: '搜索您的地址',
                        not_found: '配送地址未找到或無效，請重試',
                        not_delivering: '我們目前沒有配送到這個地址',
                        not_in_range: '您的地址不在我們商家的營業範圍內',
                        not_in_zone: '您的地址不在活動配送區域內',
                        location_permission: '允許此網站訪問您的當前位置嗎？',
                        location_permission_warning: '無法訪問您的當前位置。 請在您的設備和網絡瀏覽器上啓用定位服務。 這裏有一些參考：',
                        pick_location: '選擇您的位置',
                        pick_location_help_text: '拖動標記以選擇地圖上的位置。',
                        use_current_location: '使用當前位置',
                        locate_on_map: '在地圖上定位',
                    },
                    datetime: {
                        title: '您想點什麼時候的餐',
                        due_now: '現在',
                        due_later: '稍後',
                        service_not_available: '抱歉，我們目前不接受 {{service}}訂單',
                        currently_closed: '{{service}} 目前關閉，但您可以預訂下一天的餐',
                        due_unavailable: '暫不提供',
                        due_closed: '非營業時間',
                        select_date: '選擇日期',
                        select_time: '選擇時間',
                        select_order_date: '選擇您的訂單日期',
                        select_order_time: '選擇您的訂單時間',
                        select_order_date_time: '選擇您的訂單日期/時間',
                        select_booking_date: '選擇您的訂座預留日期',
                        select_booking_time: '選擇您的訂座預留時間',
                        no_times_available: '沒有訂座時間可供選擇',
                        date_today: '(今天)',
                        date_closed: '(關閉)',
                        date_bookings_paused: '（預訂已暫停）',
                        time_slot_closed: '關閉',
                    },
                    number_of_people: {
                        placeholder: '人數',
                    },
                    table: {
                        select: '選擇桌子',
                        select_popup_title: '選擇您的桌子',
                        password: '桌子密碼',
                        password_warning: '輸入您的桌子密碼',
                    },
                    warning: {
                        closed: '抱歉，我們現在是非營業時間/不接受任何訂單',
                        not_available: '抱歉，我們目前不接受任何訂單',
                    },
                    start_button: '開始訂單',
                },
                history: {
                    invalid: '因爲一些訂購的項目已被修改或不可再用，不可重新訂購。',
                },
                reorder: {
                    title: '快速重新訂購',
                    description: '從您以前的訂單中輕鬆再訂購',
                },
            },
            receipt: {
                errors: {
                    not_found: '訂單不存在,可能被刪除了。',
                    booking_not_found: '預訂不存在，可能已被刪除',
                    generic: '如果有問題，請刷新頁面或與我們聯繫。',
                },
                connection: {
                    connected: '實時更新',
                    connecting: '連接實時更新',
                    disconnected: '斷接實時更新',
                },
            },
            warnings: {
                logout: {
                    pretitle: '警告',
                    title: '退出',
                    body: '退出將刪除添加到購物車中的任何項目',
                    cancel: '取消',
                    proceed: '繼續',
                },
                order_restart: {
                    warning: '警告',
                    title: '更改訂單細節',
                    body: '更改您的訂單細節將可能導致您購物車中的菜品被刪除和某些菜品可能變得不可用。',
                    cancel: '取消',
                    proceed: '繼續',
                },
                order_expired: {
                    subtitle: '重要',
                    title: '更改訂單爲立即到期',
                    description: '您的訂單時間即將結束，所以您的訂單已被修改爲立即到期/儘快。',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: '重要',
                    title: '訂單截止日期即將到期',
                    description: '避免失效，請您必須在 {{time, timeFromTimestamp}} 之前下訂單',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: '取消',
                    proceed: '繼續',
                },
            },
            maps: {
                cancel: '取消',
                use_location: '使用地點',
            },
        },
        sections: {
            nav_top: {
                guest: "客人",
                login_signup: "登录 / 注册",
                logout: "退出",
            },
            menus: {
                info: {
                    no_menus: "目前没有可用菜单",
                    restrictions: "菜单限制",
                    not_available: "菜单暂不可用",
                    unavailable: {
                        times: "菜单暂不可用，您的订单要求与下面不匹配",
                        services: "菜单暂不可用，您的订单要求与下面不匹配",
                        hours: "菜单暂不可用，您的订单时间不在此菜单的可用时间内",
                        pre_order: "菜单暂不可用，您的订单与预订要求不匹配。",
                        age: "菜单暂不可用，您必须以已经通过年龄验证的帐户登录，然后再从该菜单订购",
                    },
                    services: {
                        title: "订购要求",
                        pickup: "自提",
                        delivery: "配送",
                        dine_in: "堂食",
                    },
                    times: {
                        now: "没有预订",
                        later: "只接受预订",
                    },
                    hours: {
                        title: "可选时间",
                    },
                    preorder: {
                        title: "预订需求",
                        days_in_advance: "必须提前 {{days}} 天订购",
                        cutoff_time: "截至时间为 {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "年龄限制",
                        approved: "您的帐户已经过验证，您可以从此菜单订购。",
                        rejected: "需要年龄验证才能订购。请创建一个帐户并上传您的身份证件。",
                    },
                },
            },
            info: {
                location: {
                    title: "地点",
                    view_map: "查看地图",
                    phone: "电话",
                },
                hours: {
                    title: "营业时间",
                    title_special: "特殊营业时间",
                },
                services: {
                    title: "服务",
                    notes: "备注",
                    delivery: {
                        ranges: "配送范围",
                        zones: "配送区域",
                        view_zones: "在地图查看区域",
                        fee: "配送费",
                        fee_short: '費',
                        min_order: "最低订购金额",
                        min_order_short: '最低單',
                        no_min_order: "没有最低订购金额",
                        free_amount: "免费配送金额",
                    },
                },
            },
            contact: {
                title: "聯絡我們",
                name: "名字",
                email: "电子邮箱",
                phone: "电话号码",
                message: "输入您的消息...",
                send: "发送消息",
                success: "您的消息已发送成功",
                error: "出问题了，请再试一次或稍后再试",
            },
            footer: {
                powered_by: "平台拥有和运营：",
                terms_and_conditions: "条款及细则",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: '訂座收據',
            details: {
                datetime: '預訂時間',
                number_of_people: '人數',
                placed: '預訂',
                updated: '最後更新',
                notes: '備註',
                name: '名字',
                email: '電子郵箱',
                phone: '電話',
                store_address: '商店地址',
            },
            status_update: {
                title: '預訂號碼 {{number}} 已更新',
                body: '您的預訂狀態已更新爲 {{status}}',
            },
            email_status_update_customer: {
                subject: '預訂 #{{number}} – {{subjectLabel}}',
                body: '您在 {{store}} 的預訂 #{{number}} 現為{{status}}。',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: '訂單 #{{number}} – {{subjectLabel}}',
        header: '取餐時間已更新',
        title: '取餐時間已更新',
        order_number: '訂單號: {{number}}',
        description: '您的訂單將於 {{time}} 準備完成。',
        order_time_updated_to: '您的訂單時間已更新。',
        powered_by: '供電 {{name}}',
        button_text: '跟蹤訂單',
        subject_label: '取餐時間已更新',
        subject_label_delivery: '送達時間已更新',
        body_ready: '您的訂單將於 {{time}} 準備完成。',
        body_delivery: '您的訂單將於 {{time}} 送達。',
    },
    order: {
        receipt: {
            est_ready_time: '預計食物準備時間',
            est_delivery_time: '預計配送時間',
            tab_details: '詳情',
            tab_dishes: '菜品',
            details: {
                placed: '已下單',
                due: '現在',
                due_asap: '儘快',
                last_updated: '最後更新',
                total: '總金額',
                type: '類別',
                table: '桌子',
                payment_method: '支付方式',
                payment_status: '支付狀態',
                notes: '備註',
                name: '名字',
                email: '電子郵箱',
                phone: '電話',
                delivery_address: '配送地址',
                delivery_tracking: '配送狀態查詢',
                delivery_tracking_link: '實時查詢鏈接',
                store_address: '商店地址',
            },
            dishes: {
                headings: {
                    quantity: '數量',
                    item: '商品',
                    price: '價格',
                },
                notes: '備註',
                remove_ingredients: '刪除配料',
            },
            status_update: {
                title: '訂單號 {{number}} 已更新',
                body: '您的訂單狀態已更新爲 {{status}}',
            },
            wait_time_update: {
                title: '訂單號 {{number}} 已更新',
                body: '您的訂單到期時間已更新',
            },
            delivery_update: {
                title: '訂單號 {{number}} 已更新',
                body: '您的訂單已安排配送。查看實時查詢鏈接。',
            },
            payment_status_update: {
                title: '訂單號 {{number}} 已更新',
                body: '您的訂單付款狀態已更新。',
            },
            email_new_order_restaurant: {
                subject: "新订单 ({{number}}) - {{name}}",
                powered_by: "由 {{name}} 提供",
                overview: "新订单通知",
                title: "在 {{name}} 下的新订单",
                subtitle: "订单号 {{number}}",
                description: "通过您的管理仪表板查看详细信息和更新",
                button_text: "跟踪订单",
                track_delivery_button_text: "跟踪交付",
            },
            email_new_order_customer: {
                subject: "新订单 ({{number}})",
                powered_by: "由 {{name}} 提供",
                overview: "新订单通知",
                title: "在 {{name}} 下的新订单",
                subtitle: "订单号 {{number}}",
                description: "通过您的实时在线收据查看详细信息和更新。",
                button_text: "跟踪订单",
                track_delivery_button_text: "跟踪交付",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "价格已包含 {{name}} ({{percent}}%) ",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "配送费",
            promo: "折扣: {{name}} ({{value, currency}} + {{percent}}% )",
            promo_percent: "折扣: {{name}} ({{percent}}%)",
            promo_fixed: "折扣: {{name}}",
            cart: "购物车",
            tip: "订单小费",
            total: "总金额",
        },
        status: {
            unconfirmed: "等待确认",
            awaiting_payment: "待付款",
            confirmed: "确认",
            ready: "准备好了",
            on_route: "在路上",
            complete: "完成",
            cancelled: "取消",
            seated: "已入座",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "未可用",
                },
            },
            dish: {
                no_stock: "已售馨",
                not_available: "未可用",
            },
        },
    },
};
//# sourceMappingURL=zht.js.map